export const PerfiosService = {
    postNetbanking,
    postUploadStatement
}

const { REACT_APP_CREDIT_SERVICE_API_BASE_URL } = process.env;

function postNetbanking(payload) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/banking/generate-login-payload`, requestOptions).then(handleResponse);
}

function postUploadStatement(payload) {
    const formData = new FormData();
    formData.append('app_id', payload.app_id);
    formData.append('loan_application_id', payload.loan_application_id);
    payload.statements.map((keyvalue) => {
        const keys = Object.keys(keyvalue);
        formData.append(`statements[]${keys[0]}`, keyvalue.document);
        if (keyvalue.password !== undefined)
            formData.append(`statements[]${keys[1]}`, keyvalue.password);
    })

    const requestOptions = {
        method: 'POST',
        body: formData
    };

    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/upload_statements`, requestOptions).then(handleResponse);
}

function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}